import { HitProps } from '@/components/search/types'

export function getDocumentType(hit: HitProps): string {
  let type = 'External'
  if (typeof hit?.url === 'string') {
    if (hit?.url?.match(/community\.bitwarden\.com/)) {
      type = 'Community'
    } else if (hit?.url?.startsWith('/help')) {
      type = 'Help'
    } else if (hit?.url?.startsWith('/blog')) {
      type = 'Blog'
    } else if (hit?.url?.startsWith('/resources') || hit?.url?.match(/bitwarden\.com\/.*\.pdf$/)) {
      type = 'Resources'
    } else if (hit?.url?.startsWith('/')) {
      type = 'Bitwarden'
    } else if (hit?.url?.match(/github\.com/)) {
      type = 'GitHub'
    }
  }
  return type
}

export function shouldFilterDocumentLink(link: string): boolean {
  // Exception links
  if (
    [
      'https://bitwarden.com/go/start-enterprise-trial/',
      'https://bitwarden.com/go/start-teams-trial/',
      'https://bitwarden.com/go/start-families-trial/',
    ].includes(link)
  ) {
    return false
  }

  // Skip community child posts
  if (link?.match(/community\.bitwarden\.com/) && link?.match(/\/\d+\/\d+$/)) {
    return true
  }

  // Skip pdf documents
  if (link?.match(/\.pdf$/)) {
    return true
  }

  // Skip documents with url starting with /go
  if (link?.match(/^https:\/\/bitwarden\.com\/go/)) {
    return true
  }

  return false
}
